import React from "react";
import ReactModal from "react-modal";
import { Box } from "theme-ui";

interface ModalBaseProps {
  message: string;
  isOpen: boolean;
  onConfirm: () => void;
}

function AlertModal({ isOpen, message, onConfirm }: ModalBaseProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.7)",
          padding: 0,
          width: "100%",
        },
        content: {
          borderRadius: "10px",
          height: "180px",
          left: 0,
          margin: "0 15px",
          padding: 0,
          textAlign: "center",
          top: "50%",
          transform: "translateY(-50%)",
          width: "calc(100% - 30px)",
        },
      }}
    >
      <Box sx={{ padding: "40px 25px" }}>
        <Box sx={{ fontSize: "15px" }}>
          {message.split("\\n").map((textLine, index) => (
            <Box as="p" key={`key-${index}`} mb="2px">
              {textLine}
            </Box>
          ))}
        </Box>
        <Box sx={{ marginTop: "20px" }}>
          <Box
            as="button"
            mx="2px"
            sx={{
              backgroundColor: "primaryDark",
              border: "none",
              borderRadius: "25px",
              boxSizing: "border-box",
              color: "#fff",
              cursor: "pointer",
              fontSize: "17px",
              fontWeight: "bold",
              height: "40px",
              justifyContent: "center",
              width: "80px",
            }}
            onClick={onConfirm}
          >
            확인
          </Box>
        </Box>
      </Box>
    </ReactModal>
  );
}

export default AlertModal;
